export * from './GlobalFonts';
